import { useState, useEffect, useCallback } from 'react';
import { getBCPLimits } from '../services/api';
import { BCPLimits } from '../types/bcp';

export const useBCPLimits = () => {
  const [limits, setLimits] = useState<BCPLimits | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLimits = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getBCPLimits();
      setLimits(data);
    } catch (err) {
      console.error('Failed to fetch BCP limits:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch limits');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLimits();
  }, [fetchLimits]);

  const refreshLimits = useCallback(() => {
    fetchLimits();
  }, [fetchLimits]);

  const canCreateBCP = limits?.can_create ?? false;

  return {
    limits,
    loading,
    error,
    refreshLimits,
    canCreateBCP,
    currentCount: limits?.current_count ?? 0,
    limit: limits?.limit ?? 0,
    planType: limits?.plan_type ?? 'none',
    message: limits?.message ?? '',
    upgradeSuggestion: limits?.upgrade_suggestion
  };
};
